export default "__VITE_ASSET__DHka1jZm__"